import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { intlMessageShape } from 'sb-react-intl'

import Text from 'components/_new/typography/Text/Text'
import { Icon } from 'components/_new/ui'

import s from './Title.scss'


// TODO replace "size" prop with "type: h1 | h2 | h3"
const sizes = {
  'xlg': { size: '38-48', semibold: true },
  'lg': { size: '32-40', semibold: true },
  'md': { size: '28-40', semibold: true },
  'sm': { size: '18-24', semibold: true },
}

const Title = (props) => {
  const {
    children, id, className,
    message, size, align, color, letterSpacing, tag,
    normal, uppercase, html, withMargin,
    icon, iconColor,
    dataTestId,
  } = props

  const rootClassName = cx(className, {
    [s[`margin-${size}`]]: withMargin && size,
  })

  const titleProps = {
    className: rootClassName,
    id,
    message,
    uppercase,
    letterSpacing,
    tag,
    html,
    color,
    align,
    dataTestId,
    ...(sizes[size]),
  }

  if (normal) {
    titleProps.semibold = false
  }

  const titleNode = (
    <Text {...titleProps}>
      {children}
    </Text>
  )

  if (icon) {
    return (
      <div className={s.titleWithIcon}>
        <Icon className={s.icon} name={icon} color={iconColor} />
        {titleNode}
      </div>
    )
  }

  return titleNode
}

Title.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  message: PropTypes.oneOfType([
    PropTypes.shape(intlMessageShape),
    PropTypes.string,
  ]).isRequired,
  size: PropTypes.oneOf([ 'sm', 'md', 'lg', 'xlg' ]),
  tag: PropTypes.string,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  html: PropTypes.bool,
  withMargin: PropTypes.bool,
  uppercase: PropTypes.bool,
  letterSpacing: PropTypes.bool,
  normal: PropTypes.bool,
  align: PropTypes.oneOf([ 'left', 'center', 'right' ]),
  color: PropTypes.oneOf([ 'white', 'brand' ]),
  dataTestId: PropTypes.string,
}

Title.defaultProps = {
  tag: 'div',
  size: 'md',
  withMargin: true,
}


export default Title
